const role = {
	Admin: 1,
	User: 3
};

module.exports = { role };
